import * as React from 'react';
import { ILegalForm } from '@models';
import { useTranslation, G, useResolveName, useForm } from '@components';
import './RestrictContractor.scss';

interface IProps {
    workId: number;
    oldValues: IFormValues;
    editRestriction: Function;
    handleClose: () => void;
    handleToast: (message: string, success: boolean) => void;
    canEditRestriction: boolean;
    legalForms: ILegalForm[]
}

interface IFormValues {
    id: number;
    workId: number;
    name: string;
    code: string;
    legalFormId: number;
    providerCode: string;
    contractorContactPerson: string;
    contractorEmail: string;
    contractorPhone: string;
    contractorId: number;
    applicantName: string;
    applicantEmail: string;
    reason: string;
    remarks: string;
    date: string;
}

interface IFormState {
    applicantName: string;
    applicantEmail: string;
    reason: string;
    remarks: string;
}

export function EditRestriction(props: IProps) {

    const { t } = useTranslation();
    const [disabled, setDisabled] = React.useState(false);

    const form = useForm<IFormState>({
        initialValues: {
            applicantName: props.oldValues.applicantName,
            applicantEmail: props.oldValues.applicantEmail,
            reason: props.oldValues.reason,
            remarks: props.oldValues.remarks,
        },
        validate: (data: IFormState) => {
            const errors: any = {};
            if (!data.reason?.trim()) {
                errors.reason = t('Reason is required');
            }
            return errors;
        },
        validateOnMount: true,
        validateOnChange: true,
    });

    const handleSave = async () => {
        setDisabled(true);

        const id = props.oldValues.id;
        const applicantNameValue = form.values.applicantName.trim();
        const applicantEmailValue = form.values.applicantEmail.trim();
        const reasonValue = form.values.reason.trim();
        const remarksValue = form.values.remarks.trim();

        const response = await props.editRestriction(id, applicantNameValue, applicantEmailValue, reasonValue, remarksValue)

        if(response.data.editContractorRestriction.isError || response.data.editContractorRestriction.value == 0) {
            props.handleToast(t('Error while editing restriction'), false);
            setDisabled(false);
        }else{
            props.handleClose();
        }
    }

    const resolveLegalForm = useResolveName(props.legalForms, { translate: true });

    return (
        <div className='restrict-contractor-dialog'>
            <G label={t('Contractor.Name')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.name}
                />
            </G>
            <G label={t('CIF')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.code}
                />
            </G>
            <G label={t('Legal form')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={resolveLegalForm(props.oldValues.legalFormId)}
                />
            </G>
             <G label={t('Provider code')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.providerCode}
                />
            </G>
            <G label={t('Contact person')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorContactPerson}
                />
            </G>
            <G label={t('contractor.invitation.email')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorEmail}
                />
            </G>
            <G label={t('Phone')}>
                <input
                    disabled={true}
                    className='c'
                    type='text'
                    value={props.oldValues.contractorPhone}
                />
            </G>
            <G label={t('Applicant')}>
                {form.input('applicantName', {
                    readOnly: !props.canEditRestriction,
                })}
            </G>
            <G label={t('Applicant email')}>
                {form.input('applicantEmail', {
                    readOnly: !props.canEditRestriction,
                })}
            </G>
            <G label={t('Motive')} className='restriction-reason'>
                {form.textarea('reason', {
                    readOnly: !props.canEditRestriction,
                })}
            </G>
            <G label={t('Remarks')} className='restriction-remarks'>
                {form.textarea('remarks', {
                    readOnly: !props.canEditRestriction,
                })}
            </G>
            <div className='c' />
            {props.canEditRestriction && <div className='r'>
                <span className='e' />

                <button
                    className='primary'
                    disabled={disabled}
                    onClick={() => {
                        if (form.isValid()) {
                            handleSave();
                        }
                    }}>
                    {t('Edit')}
                </button>
            </div>}
        </div>
    )
}
